import {getIdToken} from "../../../misc/miscUtils.ts";
import {URL_BASE} from "../../../../Globals.ts";

export const getUserInfo = async (user: any) => {
    try {
        if (!user?.emailVerified) {
            return {subscriptionPlan: null, remainingBalance: 0, monthlyFreeMessages: 0, isBeta: false, hasUsageBasedEnabled: false};
        }

        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/getUserInfo`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (response.ok) {
            return await response.json();
        }

        return {subscriptionPlan: null, remainingBalance: 0, monthlyFreeMessages: 0, isBeta: false, hasUsageBasedEnabled: false};
    } catch (error) {
        console.error(`Error checking user info: ${error}`);
        return {subscriptionPlan: null, remainingBalance: 0, monthlyFreeMessages: 0, isBeta: false, hasUsageBasedEnabled: false};
    }
}
